import { Browser as r } from "./browser.js";
import { Mobile as o } from "./mobile.js";
import { Terminal1 as m } from "./terminal-1.js";
import { Terminal2 as i } from "./terminal-2.js";
import { Terminal3 as t } from "./terminal-3.js";
import { Webcam as p } from "./webcam.js";
import { CashRegister as e } from "./cash-register.js";
import { Display as f } from "./display.js";
import { DisplayFilled as l } from "./display-filled.js";
import { Laptop as a } from "./laptop.js";
import { Monitor as n } from "./monitor.js";
import { Printer as s } from "./printer.js";
import { PrinterFilled as T } from "./printer-filled.js";
import { Tablet as b } from "./tablet.js";
const L = {
  Browser: r,
  Mobile: o,
  Terminal1: m,
  Terminal2: i,
  Terminal3: t,
  Webcam: p,
  CashRegister: e,
  Display: f,
  DisplayFilled: l,
  Laptop: a,
  Monitor: n,
  Printer: s,
  PrinterFilled: T,
  Tablet: b
};
export {
  L as Devices24
};
